import React from 'react'
import Header from '../components/header/Header'
import Credit from '../assets/credit-big.jpg'
import TitleText from '../utils/TitleText'
import Footer from '../components/footer/Footer'
import Contact from '../components/contact/Contact'
import Description from '../components/description/description'
import { BiCheck } from 'react-icons/bi'
import HomeButton from '../components/homebutton/HomeButton'

const CustomerCredit = () => {
    const footitems=[
        {sec:'#',title:'Home'},
        {sec:'#description',title:'Description'},
        {sec:'#contact',title:'Contact'},

    ]
    TitleText('Customer Credit Analysis')
  return (
    <>
        <HomeButton/>
        <Header text1="" text2="Customer Credit Analysis" text3="" img={Credit} />
        <Description title= 'Desciption' link ='https://github.com/Anmol23oct/Data-Analysis-with-Neo4j-and-Mongo-Db' data={
            <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Optimized Customer data in a Database to analyze credit history using mongoDb tools.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Connect cleaned data with Neo4j to construct graphs following the attributes of customers. </p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Analyze the credit score of a particular customer based on its graph attributes on Neo4j.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Technology Stack : MongoDb, Neo4j, Python.</p>
            </li>
    
          </ul>
        }/>
        <Contact/>
        <Footer footitems={footitems}/>
    </>
  )
}

export default CustomerCredit